import { useEffect, useState, type ReactNode } from 'react';
import { empresaService } from '@/shared/services/empresaService';

interface Props {
  telaId:   string;
  children: ReactNode;
}

type GateState = 'loading' | 'ok' | 'suspenso' | 'sem_jukebox' | 'erro';

/** Bloqueia Jukebox quando empresa suspensa ou plano sem jukebox_ativo. */
export default function JukeboxPlanoGate({ telaId, children }: Props) {
  const [estado, setEstado] = useState<GateState>('loading');

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const { status, jukeboxAtivo } = await empresaService.verificarAcessoJukebox(telaId);
        if (cancelled) return;

        if (status === 'suspenso') {
          setEstado('suspenso');
          return;
        }

        setEstado(jukeboxAtivo ? 'ok' : 'sem_jukebox');
      } catch {
        if (!cancelled) setEstado('erro');
      }
    })();

    return () => { cancelled = true; };
  }, [telaId]);

  if (estado === 'loading') {
    return (
      <div className="min-h-dvh bg-jukebox-bg flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-orange-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (estado === 'suspenso') {
    return (
      <div className="min-h-dvh bg-jukebox-bg flex items-center justify-center px-6 text-center">
        <div>
          <p className="text-white font-semibold">Estabelecimento indisponível</p>
          <p className="text-white/40 text-sm mt-2">Esta conta está temporariamente suspensa.</p>
        </div>
      </div>
    );
  }

  if (estado === 'sem_jukebox') {
    return (
      <div className="min-h-dvh bg-jukebox-bg flex items-center justify-center px-6 text-center">
        <div>
          <p className="text-white font-semibold">Jukebox indisponível</p>
          <p className="text-white/40 text-sm mt-2">O plano deste estabelecimento não inclui o Jukebox.</p>
        </div>
      </div>
    );
  }

  if (estado === 'erro') {
    return (
      <div className="min-h-dvh bg-jukebox-bg flex items-center justify-center px-6 text-center">
        <p className="text-white/50 text-sm">Não foi possível carregar o Jukebox.</p>
      </div>
    );
  }

  return <>{children}</>;
}
